module.exports = __webpack_public_path__ + "./images/32d187872773fc7db4d4e982c5b92f45.webp";